import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { LoginRequest } from '@/types/request/LoginRequest';

const useLogin = () => {
  const client = supabaseClient;

  const mutationFn = async (request: LoginRequest) => {
    return login(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useLogin;

async function login(client: SupabaseClient, request: LoginRequest): Promise<void> {
  const { error } = await client.auth.signInWithPassword({
    email: request.email,
    password: request.password,
  });

  if (error) throw new Error(error.message);
}
